@let foodCourtMode = isFoodCourtMode();
@let monumentInstallationMode = isMonumentInstallationMode();
@let isModeSelected = foodCourtMode || monumentInstallationMode;
<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [workspaceStateSaveValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [workspaceStateLoadValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [requestMode]="getRequestModeValue()"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'MONUMENT_INSTALLATION_REQUEST.CLIENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <gk-request-mode
      #requestModeComponent
      [formGroup]="formGroup"
      [portalId]="portalId"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></gk-request-mode>

    <section>
      @let mapSectionAlertShouldBeVisible = submitted && !isMapSectionValid();
      <div
        class="card mb-4"
        [ngClass]="
          mapSectionAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'MONUMENT_INSTALLATION_REQUEST.MAP_LOCATION' | translate }}
        </div>

        <div class="card-body">
          <gk-map
            [mapState]="mapState"
            (dispatch)="handleMapAction($event)"
          ></gk-map>

          <div class="my-2">
            @if (mapState.mapObjectTablesState[0].mapObjects.length) {
              <gk-map-object-table
                [mapState]="mapState"
                [mapObjectTableStateIndex]="0"
                (dispatch)="handleMapAction($event)"
              ></gk-map-object-table>
            }
          </div>
        </div>
        @if (mapSectionAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'LAND_PARCEL_OR_BUILDING_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <section>
      <div class="card mb-4 card-border-color-from-db">
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.DeterminationOfLocation">
            {{
              'MONUMENT_INSTALLATION_REQUEST.DETERMINATION_OF_LOCATION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.DeterminationOfLocation"
                [id]="controlName.DeterminationOfLocation"
                class="form-control form-control-sm"
                aria-required="true"
                [formControlName]="controlName.DeterminationOfLocation"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>

    @if (isModeSelected) {
      @let objectDescriptionFormControlAlertShouldBeVisible =
        submitted && !isObjectDescriptionFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            objectDescriptionFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.ObjectDescription">
              @if (foodCourtMode) {
                {{
                  'MONUMENT_INSTALLATION_REQUEST.FOOD_COURT.DESCRIPTION'
                    | translate
                }}
              }
              @if (monumentInstallationMode) {
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.DESCRIPTION'
                    | translate
                }}
              }
            </label>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <textarea
                  [name]="controlName.ObjectDescription"
                  [id]="controlName.ObjectDescription"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="controlName.ObjectDescription"
                ></textarea>
              </div>
            </div>
          </div>

          @if (objectDescriptionFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>

      @if (foodCourtMode) {
        @let foodCourtStartDateFormControlAlertShouldBeVisible =
          submitted && !isFoodCourtStartDateFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              foodCourtStartDateFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label class="mb-0" [attr.for]="controlName.FoodCourtStartDate">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.FOOD_COURT.START_DATE'
                    | translate
                }}
              </label>
            </div>

            <div class="card-body">
              <div class="input-group">
                <input
                  class="form-control form-control-sm required"
                  [attr.placeholder]="
                    'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                  "
                  [id]="controlName.FoodCourtStartDate"
                  [name]="controlName.FoodCourtStartDate"
                  [formControlName]="controlName.FoodCourtStartDate"
                  ngbDatepicker
                  #foodCourtStartDateFromDatePicker="ngbDatepicker"
                />
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="foodCourtStartDateFromDatePicker.toggle()"
                  type="button"
                ></button>
              </div>
            </div>

            @if (foodCourtStartDateFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      }

      @if (monumentInstallationMode) {
        @let workScopeFormControlAlertShouldBeVisible =
          submitted && !isWorkScopeFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              workScopeFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label class="mb-0" [attr.for]="controlName.WorkScope">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.WORK_SCOPE'
                    | translate
                }}
              </label>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    [name]="controlName.WorkScope"
                    [id]="controlName.WorkScope"
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [formControlName]="controlName.WorkScope"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <p class="text-muted m-0">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.WORK_SCOPE_DESCRIPTION'
                    | translate
                }}
              </p>
              @if (workScopeFormControlAlertShouldBeVisible) {
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>
          </div>
        </section>

        @let projectFormControlAlertShouldBeVisible =
          submitted && !isProjectFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              projectFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label class="mb-0" [attr.for]="controlName.Project">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.PROJECT'
                    | translate
                }}
              </label>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    [name]="controlName.Project"
                    [id]="controlName.Project"
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [formControlName]="controlName.Project"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <p class="text-muted m-0">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.PROJECT_DESCRIPTION'
                    | translate
                }}
              </p>
              @if (projectFormControlAlertShouldBeVisible) {
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>
          </div>
        </section>

        @let monumentInstallationDateRangeFormControlAlertShouldBeVisible =
          submitted && isMonumentInstallationDateRangeInvalid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              monumentInstallationDateRangeFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <p class="m-0">
                {{
                  'MONUMENT_INSTALLATION_REQUEST.MONUMENT_INSTALLATION.DATE_RANGE'
                    | translate
                }}
              </p>
            </div>

            <div class="card-body">
              <app-date-range-picker
                #monumentInstallationDateRangeComponent
                [currentDateIsMinDate]="true"
                (dateRangeChanged)="
                  updateMonumentInstallationDateRangeFormControl($event)
                "
                [required]="true"
              ></app-date-range-picker>
            </div>

            @if (monumentInstallationDateRangeFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger">
                  {{ 'PERIOD_INVALID' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      }
    }

    @let justificationFormControlAlertShouldBeVisible =
      submitted && !isJustificationFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          justificationFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.Justification">
            {{ 'MONUMENT_INSTALLATION_REQUEST.JUSTIFICATION' | translate }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.Justification"
                [id]="controlName.Justification"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.Justification"
              ></textarea>
            </div>
          </div>
        </div>

        @if (justificationFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredRequestMode]="true"
      [requestMode]="getRequestModeValue()"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'MONUMENT_INSTALLATION_REQUEST.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/wydanieDecyzjiMiejskiegoKonserwatoraZabytkow/podglad'
        "
        [previewRequestValidation]="validateIfRequestModeIsSelectedAndShowAlert"
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
